import React from 'react';
import RACES from '../../data/races';
import STATS from '../../data/stats';
import SectionHeader from '../ui/SectionHeader';

// ─── STEP 0: IDENTITY ───────────────────────────────────────────────────────
function IdentityStep({ character, setCharacter }) {
  const race = character.race ? RACES.find(r => r.id === character.race) : null;

  // Set random default name if empty
  React.useEffect(() => {
    if (!character.name) {
      const testNames = ["test", "test2", "test3", "test4", "test5"];
      const randomName = testNames[Math.floor(Math.random() * testNames.length)];
      setCharacter({ ...character, name: randomName });
    }
  }, []);

  return (
    <div>
      <SectionHeader>Choose Your Identity</SectionHeader>
      {/* Name */}
      <div style={{ marginBottom: 24 }}>
        <label style={{ fontFamily: "'Cinzel', serif", fontSize: "12px", color: "#8a7e5e", letterSpacing: "2px", textTransform: "uppercase", display: "block", marginBottom: 8 }}>Character Name</label>
        <input value={character.name} onChange={e => setCharacter({ ...character, name: e.target.value })}
          placeholder="Enter your character's name..."
          style={{ width: "100%", background: "rgba(20,16,10,0.6)", border: "1px solid rgba(201,168,76,0.25)", borderRadius: "6px", padding: "10px 14px", color: "#e8dcc8", fontSize: "16px", fontFamily: "'Palatino Linotype', serif" }} />
      </div>
      {/* Race Grid */}
      <label style={{ fontFamily: "'Cinzel', serif", fontSize: "12px", color: "#8a7e5e", letterSpacing: "2px", textTransform: "uppercase", display: "block", marginBottom: 10 }}>Select Race</label>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "10px" }}>
        {RACES.map(r => {
          const isSelected = character.race === r.id;
          return (
            <button key={r.id} onClick={() => setCharacter({ ...character, race: r.id, selectedPerks: [], freePerk: null, skills: {}, starSign: null })}
              style={{
                background: isSelected ? "linear-gradient(180deg, #2a1f0e, #1a1510)" : "rgba(20,16,10,0.5)",
                border: isSelected ? "1px solid #c9a84c" : "1px solid rgba(201,168,76,0.15)",
                borderRadius: "8px", padding: "12px", cursor: "pointer", textAlign: "left", transition: "all 0.2s",
                color: "#e8dcc8"
              }}>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: "14px", color: isSelected ? "#c9a84c" : "#c9a84c88", marginBottom: 6 }}>{r.name}</div>
              <div style={{ fontSize: "10px", color: "#6b6048", lineHeight: 1.5 }}>
                {["might","speed","intellect","magic"].map(s => (
                  <span key={s} style={{ marginRight: 6, color: r.stats[s] === 0 ? "#4a3030" : "#8a7e5e" }}>
                    {s.charAt(0).toUpperCase()}: {r.stats[s]}
                  </span>
                ))}
              </div>
            </button>
          );
        })}
      </div>
      {/* Race Detail Panel */}
      {race && (
        <div style={{ marginTop: 20, background: "rgba(20,16,10,0.7)", border: "1px solid rgba(201,168,76,0.2)", borderRadius: "8px", padding: "18px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
            <div style={{ fontFamily: "'Cinzel', serif", fontSize: "18px", color: "#c9a84c" }}>{race.name}</div>
            <div style={{ fontSize: "11px", color: "#6b6048" }}>Movement: {race.movement} Steps</div>
          </div>
          <p style={{ fontSize: "13px", color: "#a09070", lineHeight: 1.6, marginBottom: 14 }}>{race.description}</p>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            <div>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: "10px", color: "#6b6048", letterSpacing: 1, marginBottom: 6, textTransform: "uppercase" }}>Base Stats</div>
              <div style={{ display: "flex", gap: 10 }}>
                {STATS.map(s => (
                  <div key={s.id} style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "18px", color: s.color, fontFamily: "'Cinzel', serif" }}>{race.stats[s.id]}</div>
                    <div style={{ fontSize: "9px", color: "#6b6048", textTransform: "uppercase", letterSpacing: 1 }}>{s.label.slice(0,3)}</div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: "10px", color: "#6b6048", letterSpacing: 1, marginBottom: 6, textTransform: "uppercase" }}>Perks (choose 2 of 3)</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {race.perks.map(p => (
                  <span key={p} style={{ background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.25)", borderRadius: 4, padding: "2px 8px", fontSize: "11px", color: "#a08d4e" }}>{p}</span>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: "10px", color: "#6b6048", letterSpacing: 1, marginBottom: 6, textTransform: "uppercase" }}>Race Abilities</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {race.abilities.map(a => (
                  <span key={a.name} style={{ background: "rgba(22,160,133,0.1)", border: "1px solid rgba(22,160,133,0.3)", borderRadius: 4, padding: "2px 8px", fontSize: "11px", color: "#5dade2" }}>{a.name}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default IdentityStep
